import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21bd4bc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_6 = { class: "profile" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Sair")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Login ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppBtn = _resolveComponent("AppBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createVNode(_component_router_link, { to: "/about" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_AppBtn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Profile' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.user ? _ctx.user.displayName : ''), 1)
        ]),
        _: 1
      }),
      (_ctx.user)
        ? (_openBlock(), _createBlock(_component_AppBtn, {
            key: 0,
            onClick: _withModifiers(_ctx.logout, ["prevent"])
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_AppBtn, {
            key: 1,
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'Welcome' })), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }))
    ])
  ]))
}